var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"about-list__items"},_vm._l((_vm.aboutListItems),function(aboutListItem){return _c('AboutListItem',{key:aboutListItem.id,attrs:{"aboutListItem":aboutListItem}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }